import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { experienceLevels } from './prefectureData';
import { translations } from './config/languageConfig';

const ExperienceLevelDropdown = ({ position, onSelect, onClose, currentLanguage }) => {
  const dropdownRef = useRef(null);
  const t = translations[currentLanguage];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return createPortal(
    <div
      ref={dropdownRef}
      className="fixed bg-white rounded-xl shadow-xl border border-gray-200 p-2"
      style={{
        width: '200px',
        left: position.x,
        top: position.y,
        zIndex: 9999
      }}
    >
      {experienceLevels.map((option) => (
        <div
          key={option.level}
          onClick={() => onSelect(option.level)}
          className="flex items-center space-x-3 px-4 py-3 hover:bg-slate-50 cursor-pointer rounded-lg transition-colors"
        >
          <div className={`w-5 h-5 ${option.color} rounded-md border border-slate-200`} />
          <span className={option.textColor + " text-sm font-medium"}>{t.experiences[option.level]}</span>
        </div>
      ))}
    </div>,
    document.body
  );
};

const PrefectureShape = ({ id, name, points, textX, textY, transform = '', fill, onSelect, currentLanguage = 'en' }) => {
  const [dropdownPosition, setDropdownPosition] = useState(null);
  const shapeRef = useRef(null);

  const handleClick = (e) => {
    e.preventDefault();
    if (shapeRef.current) {
      const rect = shapeRef.current.getBoundingClientRect();
      const centerX = rect.x + rect.width / 2;
      const centerY = rect.y + rect.height / 2;
      setDropdownPosition({
        x: centerX - 100, // Center the 200px wide dropdown
        y: centerY - 150  // Position above the prefecture
      });
    }
  };

  return (
    <>
      <polygon
        ref={shapeRef}
        id={id}
        points={points}
        fill={fill}
        stroke="#333"
        strokeWidth="4"
        onClick={handleClick}
        className="cursor-pointer hover:brightness-95"
      />
      <text
        x={textX}
        y={textY}
        className="text-base fill-gray-800"
        transform={transform}
        style={{
          fontSize: '20px',
          fontWeight: '600',
          fontFamily: 'system-ui, -apple-system, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
          letterSpacing: '0.05em'
        }}
      >
        {name}
      </text>
      {dropdownPosition && (
        <ExperienceLevelDropdown
          position={dropdownPosition}
          onSelect={(level) => {
            onSelect(id, level);
            setDropdownPosition(null);
          }}
          onClose={() => setDropdownPosition(null)}
          currentLanguage={currentLanguage}
        />
      )}
    </>
  );
};

export default PrefectureShape;